export default "__VITE_ASSET__B11c849s__"